import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
// import NavOptions from "./NavOptions"

import { FaFacebookF } from "react-icons/fa"
import { FaTwitter } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"

const Footer = () => {
  const date = new Date()

  return (
    <Wrapper>
      <LogoContainer>
        <Link to="/">
          <StaticImage
            src="../images/finnick-logo-full.svg"
            alt=""
            quality="100"
            placeholder="tracedSVG"
            style={{}}
          />
        </Link>
      </LogoContainer>
      <FooterContainer>
        <TopWrapper>
          <TopContainer>
            <NavContainer>
              {/* <NavOptions /> */}
              <h4>Site Navigation</h4>
              <FooterNav>
                <FooterLink to="/">Home</FooterLink>
                <FooterLink to="/retirement-calculator">Calculator</FooterLink>
                <FooterLink to="/about">About Us</FooterLink>
                <FooterLink to="/contact">Contact</FooterLink>
                <FooterLink to="/support">Support</FooterLink>
              </FooterNav>
            </NavContainer>
            <EmailCaptureContainer>
              <h4>
                Get a weekly newsletter in your inbox with tips on saving,
                wealth & making your money work for you.
              </h4>
              <EmailCapture>
                <input type="email" placeholder="Email" />
                <button>Confirm</button>
              </EmailCapture>
            </EmailCaptureContainer>
          </TopContainer>
        </TopWrapper>
        <SocialsContainer>
          <div>
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
          </div>
          <div>
            <a href="https://www.twitter.com" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
          </div>
          <div>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </SocialsContainer>
        <Terms>
          <ul>
            <li>Terms and Conditions</li>
            <li>|</li>
            <li>Privacy Policy</li>
          </ul>
          <p>&copy; Finnick {date.getFullYear()}</p>
        </Terms>
      </FooterContainer>
    </Wrapper>
  )
}

export default Footer

const Wrapper = styled.div`
  color: #fff;
`

const LogoContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const FooterContainer = styled.div`
  background-color: #251a41;
`

const TopWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const TopContainer = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
  }
`

const NavContainer = styled.div`
  margin-top: 15px;
  margin-left: 15px;
`

const FooterNav = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`

const FooterLink = styled(Link)`
  text-decoration: none;
  color: #fff;
  margin-top: 8px;
  width: fit-content;
`

const EmailCaptureContainer = styled.div`
  margin: 25px 10px;
  max-width: 500px;

  @media screen and (min-width: 768px) {
    margin-top: 15px;
  }
`

const EmailCapture = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  input {
    color: #fff;
    background-color: #251a41;
    outline: none;
    border: none;
    border-bottom: 2px solid #555;
    transition: 0.5s;
    width: 68%;
    font-size: 1rem;

    :focus {
      border-bottom: 2px solid #ccc;
    }
  }

  button {
    background-color: #251a41;
    color: #fff;
    padding: 10px 20px;
    border: 1px solid #fff;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
`

const SocialsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  font-size: 2.1rem;

  div {
    display: flex;

    :not(:first-child) {
      margin-left: 45px;
    }

    a {
      color: #fff;
    }
  }
`

const Terms = styled.div`
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;

  li {
    display: inline;
    cursor: pointer;
  }
`
